export const initialPagination: LimitOffsetPagination = {
  offset: 0,
  limit: 12,
}

export interface LimitOffsetPagination {
  limit: number
  offset: number
}
